var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconInEarDetected = function SvgIconInEarDetected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.125 8.221c0-1.166.942-2.103 2.108-2.103.725 0 1.23.238 1.588.642.279.313.452.716.59 1.038l.057.135c.164.374.314.656.558.86.229.19.599.357 1.29.357 3.138 0 6.16 2.422 6.16 6.158a6.143 6.143 0 0 1-6.16 6.159h-.004c-3.457-.023-6.187-2.861-6.187-6.3zm2.108-1.103c-.616 0-1.108.493-1.108 1.103v6.947c0 2.904 2.302 5.279 5.192 5.299a5.143 5.143 0 0 0 5.159-5.16c0-3.122-2.51-5.157-5.16-5.157-.862 0-1.479-.212-1.93-.59-.439-.365-.665-.841-.833-1.225l-.066-.15c-.147-.34-.25-.578-.413-.76-.147-.166-.366-.307-.841-.307",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.326 18.518a3.214 3.214 0 1 0 0-6.427 3.214 3.214 0 0 0 0 6.427m0 1a4.214 4.214 0 1 0 0-8.427 4.214 4.214 0 0 0 0 8.427",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.076 14.054a.5.5 0 0 1 0 .707l-2.15 2.149-1.352-1.353a.5.5 0 1 1 .707-.707l.646.646 1.442-1.442a.5.5 0 0 1 .707 0M9.115 4.467a3.591 3.591 0 0 0-1.333 6.927l-.372.929a4.593 4.593 0 0 1 1.705-8.856 4.59 4.59 0 0 1 4.252 6.326l-.926-.378a3.591 3.591 0 0 0-3.326-4.948",
    clipRule: "evenodd"
  })));
};
export default SvgIconInEarDetected;